/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface WindDragCoefficient
 */
export interface WindDragCoefficient {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   * global drag coefficient (0-100)
   */
  value?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the WindDragCoefficient interface.
 */
export function instanceOfWindDragCoefficient(value: object): value is WindDragCoefficient {
  return true;
}

export function WindDragCoefficientFromJSON(json: any): WindDragCoefficient {
  return WindDragCoefficientFromJSONTyped(json, false);
}

export function WindDragCoefficientFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): WindDragCoefficient {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    value: json["value"] == null ? undefined : json["value"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function WindDragCoefficientToJSON(json: any): WindDragCoefficient {
  return WindDragCoefficientToJSONTyped(json, false);
}

export function WindDragCoefficientToJSONTyped(
  value?: Omit<WindDragCoefficient, "url" | "simulation" | "uid" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    value: value["value"],
  };
}
